import type { DesignBlock, DesignElement } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import type { PreviewRun } from '../../preview/previewRun'
import { BlockLinkButtons } from './BlockLinkButtons'
import { blockBackground } from './blockBackground'
import { DesignCanvas } from './design/DesignCanvas'
import { PreviewShell } from './PreviewShell'
import { pickMessages, useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  block: DesignBlock
  contentLang: ContentLang
  /** WYSIWYG включается только в большом превью и только автору курса — сигнал
   *  об этом — сам onChange: он передан только тогда, когда правка разрешена. */
  onChange?: (elements: DesignElement[]) => void
  /** Прохождение: нижняя кнопка ведёт на следующий экран (правка при этом выключена). */
  run?: PreviewRun
}

export const DesignBlockPreview = ({ block, contentLang, onChange, run }: Props) => {
  const m = useMessages(messages)
  // Экран ученика: кнопки и заголовки — на языке курса, как в плеере.
  const p = pickMessages(messages, contentLang)
  return (
    <PreviewShell
      cta={p.next}
      onCta={run?.onCta}
      style={{ background: blockBackground(block) }}
      contentClassName="min-h-0"
      aboveCta={<BlockLinkButtons buttons={block.buttons} contentLang={contentLang} />}
    >
      <DesignCanvas
        elements={block.elements}
        editable={onChange !== undefined}
        contentLang={contentLang}
        isRun={Boolean(run)}
        onChange={(next) => onChange?.(next)}
      />
    </PreviewShell>
  )
}
